import React from "react";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
    page: {
        backgroundColor: "#ffffff",
        fontSize: 15,
        flexDirection: "column",
    },
    section: {
        margin: 20,
        flexGrow: 1
    },
    row: {
        flexDirection: "row",
        alignItems: "center",
    },
    nameDesc: {
        width: "40%",
        border: "1px solid black",
    },
    zoneDesc: {
        width: "10%",
        border: "1px solid black",
    },
    description: {
        width: "25%",
        border: "1px solid black",
    },
    rowDataPadding: {
        paddingLeft: '10',
        paddingVertical: '2'
    },
    tableContainer: {
        flexDirection: "row",
        flexWrap: "wrap",
        marginHorizontal: '20'
    },
    headerText: {
        width: "50%",
        padding: '3',
        paddingBottom: '4',
        textAlign: "center"
    },
    titleText: {
        textAlign: "center",
        paddingVertical: '2'
    },
    contentText: {
        textAlign: "center"
    }
});

const PdfDocument = (props) => {
    const sortedUsers = (props.data.rsvps?.users || [])
        .slice()
        .sort((a, b) => {
            const zoneA = (a.zone ?? "").toString();
            const zoneB = (b.zone ?? "").toString();
            return zoneA.localeCompare(zoneB, undefined, { numeric: true, sensitivity: "base" });
        });
    return (
        <>
            <Document>
                <Page size="A4" style={styles.page}>
                    <View style={styles.tableContainer}>
                        <View style={styles.row}>
                            <Text style={styles.headerText}>{props.data.rsvps.miqaat}</Text>
                            <Text style={styles.headerText}>{props.data.rsvps.miqaatDate}</Text>
                        </View>
                    </View>
                    <View style={styles.tableContainer}>
                        <View style={styles.row}>
                            <Text style={styles.headerText}>Thaals: {(() => { const total = props.data.rsvps?.adultCount + props.data.rsvps?.childrenCount; const divisor = total > 130 ? 9 : 8; return Math.floor(total / divisor) + ((total % divisor > 5) ? 1 : 0); })()}</Text>
                            <Text style={styles.headerText}>Adults: {props.data.rsvps?.adultCount}</Text>
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.headerText}></Text>
                            <Text style={styles.headerText}>Children: {props.data.rsvps?.childrenCount}</Text>
                        </View>
                    </View>
                    <View style={styles.tableContainer}>
                        <View style={styles.row}>
                            <Text style={[styles.nameDesc, styles.titleText]}>Name</Text>
                            <Text style={[styles.zoneDesc, styles.titleText]}>Zone</Text>
                            <Text style={[styles.description, styles.titleText]}>Adults</Text>
                            <Text style={[styles.description, styles.titleText]}>Children</Text>
                        </View>
                    </View>
                    {
                        sortedUsers.map((user, idx) => {
                            if (user.adults !== '0') {
                                return (
                                    <View key={user._id || idx} style={styles.tableContainer}>
                                        <View style={styles.row}>
                                            <Text style={[styles.nameDesc, styles.rowDataPadding]}>{user.fullName}</Text>
                                            <Text style={[styles.zoneDesc, styles.contentText, styles.rowDataPadding]}>{user.zone ?? '-'}</Text>
                                            <Text style={[styles.description, styles.contentText, styles.rowDataPadding]}>{user.adults}</Text>
                                            <Text style={[styles.description, styles.contentText, styles.rowDataPadding]}>{user.children}</Text>
                                        </View>
                                    </View>
                                )
                            }
                            return null;
                        })
                    }
                </Page>
            </Document>
        </>
    );
}

export default PdfDocument;